module.exports = __webpack_public_path__ + "static/img/circle_item0@2x.5b37a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/channelPlanning/circle_item0@2x.png
// module id = zeiI
// module chunks = 0